module.exports = __webpack_public_path__ + "img/avatar2.2b01a1c1.png";